<template>
  <div class="container-fluid bg-primary mb-5 wow fadeIn" data-wow-delay="0.1s" style="padding: 35px">
    <div class="container">
      <div class="row g-2">
        <div class="col-sm-10">
          <div class="row g-2">
            <div class="col-sm-4">
              <input
                v-model="search.keyword"
                type="text"
                class="form-control border-0 py-3"
                placeholder="Search by location or keyword"
              />
            </div>
            <div class="col-sm-4">
              <select v-model="search.propertyType" class="form-select border-0 py-3">
                <option value="">Property Type</option>
                <option v-for="type in propertyTypes" :key="type.name" :value="type.name">{{ type.name }}</option>
              </select>
            </div>
            <div class="col-sm-4">
              <select v-model="search.offerType" class="form-select border-0 py-3">
                <option value="">Offer Type</option>
                <option v-for="offer in offerTypes" :key="offer" :value="offer">{{ offer }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-sm-2">
          <button class="btn btn-dark border-0 w-100 py-3" @click="handleSearch">Search</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import api from '../services/api'
import type { PropertyType } from '../types'

interface Search {
  keyword: string
  propertyType: string
  offerType: string
}

export default defineComponent({
  emits: ['filter-updated'],
  setup (_, { emit }) {
    const router = useRouter()
    const route = useRoute()
    const search = ref<Search>({
      keyword: '',
      propertyType: '',
      offerType: ''
    })
    const propertyTypes = ref<PropertyType[]>([])
    const offerTypes = ref(['For Sale', 'For Rent'])
    const loading = ref(true)

    // Load search filters from localStorage
    const loadFilters = () => {
      const storedFilters = localStorage.getItem('searchFilters')
      if (storedFilters) {
        try {
          search.value = JSON.parse(storedFilters)
          console.log('SearchFilter: Loaded filters from localStorage:', search.value)
        } catch (error) {
          console.error('SearchFilter: Error parsing localStorage filters:', error)
        }
      }
    }

    // Fetch property types from API
    const fetchPropertyTypes = async () => {
      try {
        const response = await api.get('/estate/property-types')
        propertyTypes.value = response.data
        console.log('SearchFilter: Fetched property types:', propertyTypes.value)
      } catch (error) {
        console.error('SearchFilter: Error fetching property types:', error)
        propertyTypes.value = []
      } finally {
        loading.value = false
      }
    }

    // Handle search
    const handleSearch = () => {
      console.log('SearchFilter: Handling search with filters:', search.value)
      // Store filters in localStorage
      localStorage.setItem('searchFilters', JSON.stringify(search.value))

      // If already on /properties, emit event to update filters
      if (route.path === '/properties') {
        console.log('SearchFilter: Emitting filter-updated event with:', search.value)
        emit('filter-updated', { ...search.value })
      } else {
        console.log('SearchFilter: Redirecting to /properties')
        router.push('/properties')
      }
    }

    // Initialize on mount
    onMounted(() => {
      loadFilters()
      fetchPropertyTypes()
    })

    return {
      search,
      propertyTypes,
      offerTypes,
      handleSearch,
      loading
    }
  }
})
</script>
